import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllRelatedCustomer: build.query({
      query: () => ({
        url: `/order/get/customer/64103e0fe155df66d4a64c45?page=1&size=10&status=request`,
        method: "GET",
      }),
    }),
    getAllOrderRelatedSubs: build.query({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const subscriptionId = JSON.parse(localStorage.getItem("user"))?.subscription?._id
        if (subscriptionId !== "" && subscriptionId !== null) {
          console.log("_arg", _arg)
          const orderResponse = await fetchWithBQ({
            url: `/order/get/${subscriptionId}?page=1&size=10&status=request`,
            method: "GET",
          });
          if (orderResponse.error) return orderResponse.error;

          return orderResponse.data
        }
        return []
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetAllOrderRelatedSubsQuery
} = extendedApi